import { useParams } from "react-router-dom";

import { useFragment } from "@apollo/client";

import { type LensSpace } from "../../gql-generated/types";
import { lensSpace } from "../api/fragments";

import { useSearchParams } from "./useSearchParams";

export enum LensFoldersSearchParams {
    LensFolder = "lens-folder",
}

export const useSelectedLensFolderV3 = (): LensSpace | null => {
    const { lensFolderId } = useParams<{ lensFolderId?: string }>();
    const searchParams = useSearchParams();
    const searchParamsLensFolder = new URLSearchParams(window.location.search);
    const id =
        lensFolderId ??
        searchParams.get(LensFoldersSearchParams.LensFolder) ??
        searchParamsLensFolder.get(LensFoldersSearchParams.LensFolder);

    const { data, complete } = useFragment<LensSpace>({
        fragment: lensSpace,
        fragmentName: "LensSpaceAll",
        from: {
            __typename: "LensSpace",
            id,
        },
    });

    return complete ? data : null;
};
